<template>
    <div class="left_panel order_detail_left_panel">
        <h2 class="font_size_20">Order Details</h2>
        <div class="contact_detail_wrap top_wrap position-relative order_details_shipping" v-if="order">
            <div class="row">
                <div class="col-lg-3 col-md-4 custom-break-3">
                    <div class="order_num">
                        <h3>#{{ order.unique_order_id }}</h3>
                        <p v-if="order.netsuite_so_number" class="font_size_14">
                            SO Number: <b>{{ order.netsuite_so_number?order.netsuite_so_number:"-" }} </b>
                        </p>
                        <p class="font_size_14">
                            Ordered On: {{ order.created_at | formatDate }}
                        </p>
                        <div class="back_order_btn">                            
                            <span class="btn red_color font_size_14" style="cursor: text;">{{ order.status }}</span>
                        </div>                        
                    </div>
                </div>
                <div class="col-lg-3 col-md-3 custom-break-3" v-if="order.NewOrderAddresses.length > 0">
                    <div class="order_num">
                        <h3>
                            {{ order.NewOrderAddresses[0].fullname }}
                        </h3>
                        <div class="bill_details font_size_14">
                            
                            <p>BILL TO</p>
                            
                            <div class="bill-details">
                                 <span class="d-block" v-if="billing_address.address_label">
                                     <b>Company Name:</b>
                                    {{ billing_address.address_label }}
                                </span>
                             <span class="d-block" v-if="billing_address.first_name && billing_address.last_name">
                                <b>Recipient Name:</b> {{ billing_address.first_name+" "+billing_address.last_name }}
                                </span>
                                <span class="d-block" v-else>
                                    {{ order.NewOrderAddresses[0].fullname }}
                                </span>  
                              <!--   <span class="d-block"> {{ billing_address.address1 + ' ' + billing_address.address2 }}</span>
                                <span class="d-block"> {{ billing_address.city }}</span>
                                <span class="d-block"> {{ billing_address.zip }} {{ billing_address.state }} {{ billing_address.country }}</span> -->
                                
                                <span class="d-block" v-if="billing_address.address1">
                                    {{ billing_address.address1 }}<br />
                                </span>
                                <span class="d-block" v-if="billing_address.address2">
                                    {{ billing_address.address2 }}<br />
                                </span>

                                <span class="d-block"
                                    v-if="
                                        billing_address.city ||
                                        billing_address.state ||
                                        billing_address.zip
                                    "
                                >
                                    {{
                                        [
                                            billing_address.city,
                                            billing_address.state
                                        ]
                                            .filter(Boolean)
                                            .join(", ") +
                                        (billing_address.zip
                                            ? " " + billing_address.zip
                                            : "")
                                    }}
                                </span>
                            </div>
                            <div class="contact-info">
                                <span><img alt="" src="/maincss/images/icons/call.svg" /></span>
                                <a :href="'tel:' + billing_address.phone">
                                    <span>{{ billing_address.phone }}</span>
                                </a>
                            </div>
                            <div class="contact-info">
                                <span><img alt="" src="/maincss/images/icons/envelope.svg" /></span>
                                <a :href="'mailto:' + billing_address.email">
                                    <span>{{ billing_address.email }}</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-md-3 custom-break-3 pl_30" v-if="order.NewOrderAddresses.length > 0">
                    <div class="order_num mt_38">
                        <div class="bill_details font_size_14">
                            <p>SHIP TO</p>
                             
                            <div class="bill-details">
                            
                               <!--  <span class="d-block"> {{ shipping_address.address1 + ' ' + shipping_address.address2 }}</span>
                                <span class="d-block"> {{ shipping_address.city }}</span>
                                <span class="d-block"> {{ shipping_address.zip }} {{ shipping_address.state }} {{ shipping_address.country }}</span> -->

                                <span class="d-block"
                                    v-if="
                                        shipping_address.shippingaddress_label
                                    "
                                >   <b>Company Name:</b>
                                    {{
                                        shipping_address.shippingaddress_label
                                    }}<br />
                                </span>
                                   <span class="d-block" v-if="shipping_address.first_name && shipping_address.last_name">
                                                        <b>Recipient Name:</b> {{ shipping_address.first_name+" "+shipping_address.last_name }}
                                                        </span>
                                                         <span class="d-block" v-else>
                                                         {{ order.NewOrderAddresses[0].fullname }}
                                                        </span> 
                                <span class="d-block" v-if="shipping_address.address1">
                                    {{ shipping_address.address1 }}<br />
                                </span>
                                <span class="d-block" v-if="shipping_address.address2">
                                    {{ shipping_address.address2 }}<br />
                                </span>

                                <span class="d-block"
                                    v-if="
                                        shipping_address.city ||
                                        shipping_address.state ||
                                        shipping_address.pincode
                                    "
                                >
                                    {{
                                        [
                                            shipping_address.city,
                                            shipping_address.state
                                        ]
                                            .filter(Boolean)
                                            .join(", ") +
                                        (shipping_address.zip
                                            ? " " +
                                              shipping_address.zip
                                            : "")
                                    }}
                                </span>
                            </div>
                            <div class="contact-info">
                                <span><img alt="" src="/maincss/images/icons/call.svg" /></span>
                                <a :href="'tel:' + shipping_address.phone">
                                    <span>{{ shipping_address.phone }}</span>
                                </a>
                            </div>
                            <div class="contact-info">
                                <span><img alt="" src="/maincss/images/icons/envelope.svg" /></span>
                                <a :href="'mailto:' + shipping_address.email">
                                    <span>{{ shipping_address.email }} </span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-md-3 custom-break-3 pl_30">
                    <div class="order_num mt_38">
                        <div class="bill_details font_size_14 text-capitalize">
                            <p class="ship_to">Shipping Method</p>
                            <label>{{order.ShippingCarrier.shpping_provider || capitalize}}: </label>
                            <span>   {{order.ship_method}}</span>
                        </div>
                    </div>
                    <div class="order_num mt_10">
                        <div class="bill_details font_size_14">
                            <p class="ship_to">Payment Method</p>
                        </div>
                        <div class="sub_text name_sub_text_custom " v-if="card_payment_details && card_payment_details.payment_details && card_payment_details.payment_details.remaining_pay_card_details">
                            <p>Payment Type: Card</p>
                            <p>Card Type: {{card_payment_details.payment_details.remaining_pay_card_details.cardtype}}</p>
                            <p>Card No: <span>XXXX XXXX XXXX {{card_payment_details.payment_details.remaining_pay_card_details.cardnumber}}</span></p>
                            <p>Card Amount: <span>{{ icPriceFormat(card_payment_details.amount) }}</span></p>
                        </div>
                        <div class="sub_text name_sub_text_custom " v-else-if="card_payment_details && card_payment_details.payment_details">
                            <p>Payment Type: Card</p>
                            <p>Card Type: {{card_payment_details.payment_details.cardtype}}</p>
                            <p>Card No: <span>XXXX XXXX XXXX {{card_payment_details.payment_details.cardnumber}}</span></p>
                            <p>Amount: <span>{{ icPriceFormat(card_payment_details.amount) }}</span></p>
                        </div>
                        <div class="sub_text name_sub_text_custom mt-2" v-if="term_payment_details && term_payment_details.payment_details && (parseFloat(term_payment_details.payment_details.credit_reduce) > 0)">
                            <p>Payment Type: Term Payment</p>
                            <p>Credit Applied: {{ icPriceFormat(term_payment_details.payment_details.credit_reduce) }}</p>
                            <p>Available Credit: {{ icPriceFormat(term_payment_details.payment_details.remaining_balance) }}</p>
                        </div>
                    </div>  
                </div>
            </div>
        </div>
        <div class="contact_detail_wrap top_wrap position-relative order_details_shipping" v-if="order && (additional_card_payment || additional_term_payment)">
            <div class="row">

                <div class="col-lg-3 col-md-3 custom-break-3 pl_30">
                    <div class="order_num mt_10">
                        <h3>Additional Payment</h3>
                        <div class="bill_details font_size_14">
                            <p class="ship_to">Payment Method</p>
                        </div>
                        <div class="sub_text name_sub_text_custom " v-if="additional_card_payment && additional_card_payment.payment_details && additional_card_payment.payment_details.remaining_pay_card_details">
                            <p>Payment Type: Card</p>
                            <p>Card Type: {{additional_card_payment.payment_details.remaining_pay_card_details.cardtype}}</p>
                            <p>Card No: <span>XXXX XXXX XXXX {{additional_card_payment.payment_details.remaining_pay_card_details.cardnumber}}</span></p>
                            <p>Card Amount: <span>{{ icPriceFormat(additional_card_payment.amount) }}</span></p>
                        </div>
                        <div class="sub_text name_sub_text_custom " v-else-if="additional_card_payment && additional_card_payment.payment_details">
                            <p>Payment Type: Card</p>
                            <p>Card Type: {{additional_card_payment.payment_details.cardtype}}</p>
                            <p>Card No: <span>XXXX XXXX XXXX {{additional_card_payment.payment_details.cardnumber}}</span></p>
                            <p>Amount: <span>{{ icPriceFormat(additional_card_payment.amount) }}</span></p>
                        </div>
                        <div class="sub_text name_sub_text_custom mt-2" v-if="additional_term_payment && additional_term_payment.payment_details">
                            <p>Payment Type: Term Payment</p>
                            <p>Credit Applied: {{ icPriceFormat(additional_term_payment.payment_details.credit_reduce) }}</p>
                            <p>Available Credit: {{ icPriceFormat(additional_term_payment.payment_details.remaining_balance) }}</p>
                        </div>
                    </div>  
                    <div class="order_num mt_10" v-if="additional_payment">
                        <div class="bill_details font_size_14">
                            <p class="ship_to">Additional Fees</p>
                        </div>
                        <div class="sub_text name_sub_text_custom ">
                            <p v-if="additional_payment.color_fees">Color Fees: {{ icPriceFormat(additional_payment.color_fees) }}</p>
                            <p v-if="additional_payment.item_fees">Item Fees: {{ icPriceFormat(additional_payment.item_fees) }}</p>
                            <p v-if="additional_payment.order_fees">Order Fees: {{ icPriceFormat(additional_payment.order_fees) }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- FINANCE STATUS -->
        <div class="card steps_card" v-if="order">
            <section class="order-details-steps pb-0 ">
                <div class="container">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="border"></div>
                            <div class="wizard d-flex justify-content-center align-items-center">
                                <div class="field d-flex justify-content-center align-items-center">
                                    <div class="circle" :class="{ 'done': order.finance_check == 'Approved' }">
                                        <img src="/maincss/images/checked_icon.png" alt
                                            class="checked-block" />
                                    </div>
                                    <h5 class="mb-0">Finance</h5>
                                </div>

                                <div class="field d-flex justify-content-center align-items-center">
                                    <div class="circle" :class="{ 'done': order.art_dept == 'Approved' }">
                                        <img src="/maincss/images/checked_icon.png" alt
                                            class="checked-block" />
                                    </div>
                                    <h5 class="mb-0">Art/Design</h5>
                                </div>

                                <div class="field d-flex justify-content-center align-items-center">
                                    <div class="circle dot" :class="{ 'done': order.production == 'Approved' }">
                                        <img src="/maincss/images/checked_icon.png" alt
                                            class="checked-block" />
                                    </div>
                                    <h5 class="mb-0">Production</h5>
                                </div>
                                <div class="field d-flex justify-content-center align-items-center">
                                    <div class="circle dot" :class="{ 'done': order.shipped == 'Approved' }">
                                        <img src="/maincss/images/checked_icon.png" alt
                                            class="checked-block" />
                                    </div>
                                    <h5 class="mb-0">Shipped</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>

        <!-- Order Details Component for Products Display -->
        <OrderDetails 
            v-if="order && processedOrderData" 
            :order_data="processedOrderData" 
            :total_non_standard_colors="total_non_standard_colors"
        />
        
        <!-- Fallback: Original structure if OrderDetails component not available -->
        <div class="accordian_detals contact_detail_wrap account_detail_left_rt product_information_main_box_custom" v-else-if="order">
            <div class="acc">
                <div class="acc__card">
                    <div class="acc__title acc_head">Base Product</div>
                    <div class="acc__panel order-list-page">
                        <template v-if="!order.NewOrderItems || order.NewOrderItems.length === 0">
                            <div class="text-center p-4">
                                <p>No products found in this order.</p>
                            </div>
                        </template>
                        <template v-else>
                        <div class="row border_row base_pro_row_custom " v-for="(item, index) in order.NewOrderItems" :key="index">
                            <div class="col-md-4 order-list-col">
                        <h4 class="mt_20">Base Product</h4>


                                <div class="acc_wrap">
                                    <!-- <h4>Base Product</h4> -->
                                    <div class="acc_content  d-flex">
                                        <div class="acc_img">
                                            <DisplayProductImage :whateverActivatesThisLink="false" :designImage="item.design_image ? item.design_image.split(',')[0] : item.design_image"
                                                :product="item" :color="item.color && item.color.id ? item.color.id : null" :classValue="'mr-auto'" />
                                                 <a
                          href="#"
                          class="hover_search "
                          data-toggle="modal"
                          :data-target="'#imagepreview-' + index"
                        >
                          <img src="/maincss/images/zoom.svg" alt=" " />
                        </a>
                        <span class="text-center d-block font-weight-bold"> {{ item.product_number || '-' }}</span>
                                        </div>
                                        <div class="acc_right">
                                            <h5 v-tooltip="item.name" v-if="
                                                item.name &&
                                                item.name.length >= 50
                                            " class="font_size_16">
                                                {{
                                                        item.name
                                                        | productTitleExceed
                                                        | capitalize
                                                }}
                                            </h5>
                                            <h5 v-else-if="item.name" class="font_size_16">
                                                {{ item.name | capitalize }}
                                            </h5>
                                            <h5 v-else class="font_size_16">
                                                Product
                                            </h5>
                                            <div class="color_cat d-flex" v-if="item.color">
                                                <div class="pro_color">
                                                    <span class="font_size_14">color:</span>
                                                    <span v-tooltip="item.color.name" v-html="productColors(item.color)"></span>
                                                </div>
                                            </div>

                                            <div class="pro_size d-flex font_size_14"
                                                v-for="(size_data, key) in item['sizes']" :key="'size-' + key">
                                                <span>{{ size_data.MainNewSubProduct.Size.size }}:</span>
                                                <span class="size">{{ size_data.quantity }} @ {{
                                                        icPriceFormat(size_data.price)
                                                }}
                                                    = 
                                                    {{
                                                            size_data.total_price
                                                                ? icPriceFormat(size_data.total_price)
                                                                : ""
                                                    }}</span>
                                                <span v-if="size_data.discount>0">
                                                    <div class="dropdown">
                                                        <a
                                                            href="#"
                                                            class="dropdown-toggle d-flex align-items-center"
                                                            :id="'dropdownMenuButton' + size_data.id"
                                                            data-toggle="dropdown"
                                                            aria-haspopup="true"
                                                            aria-expanded="false"
                                                            @click="openCostPopup(size_data.id)"
                                                        >
                                                            <img src="/maincss/images/information.svg" class="ml_6" />
                                                        </a>
                                                        <div class="dropdown-menu drop-base-menu" aria-labelledby="dropdownMenuButton">
                                                            <h4 class="font_size_16 text_primary_blue py_2 px_20">
                                                                Price
                                                                <span class="cross_ic">
                                                                    <img src="/maincss/images/cross.svg" />
                                                                </span>
                                                            </h4>
                                                            <div class="scroll">
                                                                <div class="dropdown-item d-flex align-items-center">
                                                                    <p class="font-weight-bold w-25">Base Price:</p>
                                                                    <p class="ml-auto">
                                                                         {{
                                                                            size_data.total_price
                                                                            ? icPriceFormat(parseFloat(size_data.total_price) + parseFloat(size_data.discount))
                                                                            : icPriceFormat(0)
                                                                        }}
                                                                    </p>
                                                                </div>
                                                                <div class="dropdown-item d-flex align-items-center">
                                                                    <p class="font-weight-bold w-25">Discount:</p>
                                                                    <p class="ml-auto">
                                                                        - {{ icPriceFormat(size_data.discount) }}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </span>
                                            </div>
                                            <div class="pro_qnt font_size_14">
                                                Total Quantity : {{ Number(item.total_quantity) }}
                                            </div>
                               
                  
                                        </div>
                                    </div>
                                    <div class="table-btn-col">
                                        <!-- <div class="data-export-btn">   <a class="export-btn btn btn_outline_primary buttons" href="">Export</a></div> -->
                                               
                    <table v-if="item.name_and_number_json.length > 0" class="name-number-data">
                        <thead class="data-head">
                          <tr class="cart-data-col">
                          <th v-if="existsNameAndNumber(item.name_and_number_json, 'name')" class="data-heading">Name</th>
                          <th v-if="existsNameAndNumber(item.name_and_number_json, 'number')" class="data-heading">Number</th>
                          <th  class="data-heading">Size</th>
                        </tr>
                      </thead>
                        <tbody class="data-body">
                          <tr v-for="(namesAndNumber, key ) in item.name_and_number_json" :key="key" class="cart-data-col">
                          <td v-if="existsNameAndNumber(item.name_and_number_json, 'name')">{{namesAndNumber.name}}</td>
                          <td v-if="existsNameAndNumber(item.name_and_number_json, 'number')">{{namesAndNumber.number}}</td>
                          <td>{{namesAndNumber.size}}</td>
                        </tr>
                        </tbody>
                      </table>
                </div>
                      
                                </div>
                            </div>
                            <div class="modal fade cart_preview" :id="'imagepreview-' + index" data-backdrop="static" data-keyboard="false"
                              tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                              <div class="modal-dialog modal-dialog-centered cart_modal_s" style="max-width: 823px;
                                width: 100%;">
                                <div class="modal-content">
                                  <div class="modal-header border-bottom-0 p-0">
                                    <div class="order-number"><h3 >Order Number-: <span><b>#{{ order.unique_order_id }}</b></span> </h3></div>
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                      <img src="/maincss/images/cancel.svg" />
                                    </button>
                                  </div>
                                  <div v-if="item.design_images && (item.design_images.length > 0)" class="modal-body pt-0">

                                    <div :class="'canvas_auto_preview_images ' + (item.design_images && (item.design_images.length > 0) ? 'new_canvas_images' + item.design_images.length :'')" style="display:flex; margin-top: 20px;">
                                      <div class="mx-auto preview-image" style="padding-left: 10px; "
                                        v-for="(design_img, index) in item.design_images" :key="index">
                                        <h4>{{ design_img.label.replace(/(?:^|\s|-)\S/g, x => x.toUpperCase()) }}</h4>
                                        <DisplayProductImage :product="item" :classValue="'m-auto'" :designImage="design_img.url"
                                          :color="item.color && item.color.id ? item.color.id : null" :backgroundColorHex="((design_img.label.replace(
                                        /(?:^|\s|-)\S/g,
                                        (x) => x.toUpperCase()
                                      ) == 'Left') || (design_img.label.replace(
                                        /(?:^|\s|-)\S/g,
                                        (x) => x.toUpperCase()
                                      ) == 'Right'))?(item.color && item.color.hex ? item.color.hex : ''):''" :whateverActivatesThisLink="false" />
                                        <!-- <h3>{{ item.product.name | capitalize }}</h3> -->
                                      </div>
                                    </div>

                                  </div>
                                  <div v-else class="modal-body pt-0">
                            
                                    <div class='canvas_auto_preview_images new_canvas_images1'
                                    style="display:flex; margin-top: 20px;">
                                    <div class="mx-auto preview-image" style="padding-left: 10px; ">
                                        <div class="product-box">
                                            <img v-if="item.design_image" :src="item.design_image ? item.design_image.split(',')[0] : item.design_image"
                                                class="img-fluid" />
                                            <img v-else-if="item.product_image" :src="item.product_image.url" class="img-fluid" />
                                        </div>
                                    </div>
                                </div>
                          
                          </div>
                                </div>
                              </div>
                            </div>
                            <!-- v-if="item.NewOrderItemDecoration.art_work" -->

                            <div class="modal fade text-left"
                                :id="'canvas-images-model-' + index" tabindex="-1"
                                role="dialog" aria-labelledby="basicModalLabel3"
                                aria-hidden="true" data-backdrop="static"
                                data-keyboard="false">
                                <div class="modal-dialog modal-dialog-centered manage_add_shap_custom cart_modal_s-img"
                                    role="document">
                                    <div class="modal-content">
                                        <div class="modal-header">
                                            <button type="button" class="close"
                                                data-dismiss="modal" aria-label="Close">
                                                <img src="/maincss/images/cancel.svg"
                                                    alt=" " />
                                            </button>
                                        </div>
                                        <div class="modal-body modal-scroll"
                                            v-if="item.design_images">
                                            <div class=""
                                                v-for="(design_image, index) in item.design_images"
                                                :key="index">
                                                <div class="row main_title">
                                                    <h5 class="cart_popup_title"
                                                        v-if="design_image.canvas_images.length > 0">
                                                        {{
                                                            design_image.label.replace(/(?:^|\s|-)\S/g,
                                                                x => x.toUpperCase()) }}</h5>
                                                </div>

                                                <div class="row image-align-col">
                                                    <div class="col product_details-cart"
                                                        v-for="(canvas_image, canvas_image_index) in design_image.canvas_images"
                                                        :key="canvas_image_index">
                                                        <div class="choice_img"><img
                                                                :src="canvas_image.image_path"
                                                                class="mt_10">
                                                            <label class="order_shape_title"
                                                                v-tooltip="canvas_image.image_name">{{
                                                                    canvas_image.image_name
                                                                }}</label>
                                                            <label
                                                                class="dimension_text">Artwork Size
                                                                {{ canvas_image.width_inch
                                                                }}
                                                                <span>&#8243;</span>
                                                                <b>&#215;</b>
                                                                {{ canvas_image.height_inch
                                                                }}
                                                                <span>&#8243;</span></label>
                                                        </div>
                                                        <!-- <div class="img_name">{{ canvas_image.image_name }}</div> -->
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div  class="col-md-5 order-list-col-sec">
                                <h4 class="mt_20">Artwork</h4>
                                <div class="acc_wrap">                                    
                                    <div class="acc_content row" v-if="item.NewOrderItemDecoration.art_work || item.front_art_url">
                                        <div class="col-md-3">
                                            <div class="order_artwork_img acc_img">

                                                <img v-if="item.NewOrderItemDecoration.art_work" :src="item.NewOrderItemDecoration.art_work" alt=""
                                                    width="50px" srcset="" />
                                                <img v-else-if="item.front_art_url" :src="item.front_art_url" alt=""
                                                    width="50px" srcset="" />
                                                <img v-else alt="" src="/maincss/images/mug_2.png" />
                                                <p class="hover_searc_p_custom">
                                                <a
                                                    href="#"
                                                    class="hover_search"
                                                    data-toggle="modal"
                                                    :data-target="`#artworkpreview-${index}`"
                                                >
                                                    <span class="bg_span_color zoom_img_icon">
                                                        <img src="/maincss/images/zoom.svg" alt=" " class="search_hover_img_tag">
                                                    </span>
                                                </a>
                                                </p>
                                            </div>
                                            
                                            <a
                                                v-if="showDesignImages(item.design_images)"
                                                type="button"
                                                class="images-popup-btn btn btn_outline_primary buttons image-button-design"
                                                :data-target="`#canvas-images-model-${index}`"
                                                data-toggle="modal"
                                            >
                                                Images
                                            </a>
                                        </div>

                                        <div class="col-md-9">
                                            <div class="acc_right">
                                                <div class="color_cat d-flex">
                                                    <div class="font_size_14">
                                                        <span v-if="item.OrderBuild">Build Name: <b> {{ item.OrderBuild.name }} </b><br/> </span>
                                                        <span v-if="item.NewOrderItemDecoration" >Decoration Type: <b>{{ getDecorationMethodName(item.NewOrderItemDecoration.decoration_type) }} </b></span>
                                                    </div>
                                                </div>
                                                <div class="pro_qnt font_size_14" v-if="item.design_fee > 0">
                                                    Design Price: {{ icPriceFormat(item.design_fee) }}
                                                </div>
                                            </div>

                                            <ul v-if="item.decoration_colors.length > 0" class="standard_colors mt-2">
                                                <span class="mr-2 font_size_14">Decoration Colors:</span>
                                                <li 
                                                    v-for="( color, index ) in item.decoration_colors"
                                                    :style="'background-color:' + color.hex + ';'" 
                                                    :key="index"
                                                    v-tooltip = "{
                                                        'content': color.name ? `${color.name}<br/>${color.hex}` : color.hex,
                                                        'html': true,
                                                        'autoHide': false
                                                    }"
                                                >
                                                </li>                                        
                                            </ul>
                                        </div>
                                    </div>                                                                                                              
                                </div>
                            </div>
                            
                            <div class="col-md-3 order-list-col-sec-last">
                                <h4 class="mt_20">Cost</h4>
                                <div class="acc_wrap">
                                    <div class="cost_col">
                                        
                                        <div class="cost_v d-flex font_size_14" v-if="item.name_number_fees > 0">
                                            <span>Name & Number Fees</span>
                                            <span>{{ icPriceFormat(item.name_number_fees) }}</span>
                                        </div>
                                        <div class="cost_v d-flex font_size_14" v-if="item.setup_fee > 0">
                                            <span>Set up Fee</span>
                                            <span>{{ icPriceFormat(item.setup_fee) }}</span>
                                        </div>
                                        <div class="cost_v d-flex font_size_14" v-if="item.total_extra_fees > 0">
                                            <span class="d-flex align-items-center base_product_box_custom">
                                                Decoration fees

                                                <span class="p-0" v-if="item.total_extra_fees > 0">
                                                    <div class="dropdown">
                                                        <a
                                                            href="#"
                                                            class="dropdown-toggle m-0 d-flex align-items-center"
                                                            :id="'dropdownMenuButton' + index"
                                                            data-toggle="dropdown"
                                                            aria-haspopup="true"
                                                            aria-expanded="false"
                                                            @click="openCostPopup(index)"
                                                        >
                                                            <img src="/maincss/images/information.svg" class="ml_6" />
                                                        </a>
                                                        <div class="dropdown-menu drop-order-menu" aria-labelledby="dropdownMenuButton">
                                                            <h4 class="font_size_16 text_primary_blue py_2 px_20">
                                                                Decoration Fees
                                                                <span class="cross_ic">
                                                                    <img src="/maincss/images/cross.svg" />
                                                                </span>
                                                            </h4>
                                                            <div class="scroll">
                                                                <div v-if="item.total_single_location_price > 0">
                                                                    <div class="dropdown-item d-flex align-items-center">
                                                                        <p class="font-weight-bold w-25">Single Location Fee: </p>
                                                                        <p class="ml-auto">
                                                                            {{ icPriceFormat(item.total_single_location_price) }}
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                                <div v-if="item.design_fee > 0">
                                                                    <div class="dropdown-item d-flex align-items-center">
                                                                        <p class="font-weight-bold w-25">Design Fee: </p>
                                                                        <p class="ml-auto">
                                                                            {{ icPriceFormat(item.design_fee) }}
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                                <div v-for="(location, location_index) in item.imprint_locations" :key="location_index">
                                                                    <div class="dropdown-item d-flex align-items-center">
                                                                        <p class="font-weight-bold w-25">Imprint Location: {{ location.location }}</p>
                                                                        <p class="ml-auto">{{ icPriceFormat(location.total_decoration_fee) }}</p>
                                                                    </div>
                                                                    <div v-for="(colors, color_index) in location.colors" :key="color_index" class="dropdown-item d-flex align-items-center">
                                                                        <p v-if="colors.color" class="font-weight-bold w-25">Color {{color_index+1}} - {{ colors.color.color_name }}:</p>
                                                                        <p v-if="colors.total_decor_upcharge" class="ml-auto">
                                                                            {{ icPriceFormat(colors.total_decor_upcharge) }}
                                                                        </p>
                                                                        <!-- <p v-if="colors.decor_upcharge" class="ml-auto">
                                                                            {{ icPriceFormat(parseFloat(colors.cost_cost)+parseFloat(colors.decor_upcharge.color_cost)) }}
                                                                        </p>
                                                                        <p v-else class="ml-auto">
                                                                            {{ icPriceFormat(colors.cost_cost) }}
                                                                        </p> -->
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                 </span>
                                            </span>

                                            <span>{{ icPriceFormat(item.total_extra_fees) }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- ARTWORK MODAL -->
                            <div
                                class="modal fade cart_preview"
                                :id="`artworkpreview-${index}`"
                                data-backdrop="static"
                                data-keyboard="false"
                                tabindex="-1"
                                aria-labelledby="staticBackdropLabel"
                                aria-hidden="true"
                            >
                                <div class="modal-dialog modal-dialog-centered">
                                    <div class="modal-content">
                                        <div class="modal-header border-bottom-0 p-0">
                                            <button
                                                type="button"
                                                class="close py-2 pr-3"
                                                data-dismiss="modal"
                                                aria-label="Close"
                                            >
                                                <img src="/maincss/images/cancel.svg" />
                                            </button>
                                        </div>
                                        <div class="modal-body pt-0">
                                            <div class="mx-auto preview-image mb_20">
                                                <img v-if="item.NewOrderItemDecoration.art_work" :src="item.NewOrderItemDecoration.art_work" alt="">
                                                <img v-else-if="item.front_art_url" :src="item.front_art_url" alt="">
                                                <img v-else alt="" :id="`default-artwork-${index}`" src="/maincss/images/mug_2.png" />
                                            </div>
                                            <div class="mx-auto preview-image">
                                                <button v-if="item.NewOrderItemDecoration.art_work" class="btn btn_orange bg_primary_orange text_white" type="button" @click="downloadArtwork(item.NewOrderItemDecoration ? item.NewOrderItemDecoration.final_proof_image : '', 'FinalProofImage', index)">Download</button>
                                                <button v-else-if="item.front_art_url" class="btn btn_orange bg_primary_orange text_white" type="button" @click="downloadArtwork(item.front_art_url, 'Artwork', index)">Download</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div
                                class="modal fade cart_preview"
                                :id="`finalproofimagepreview-${index}`"
                                data-backdrop="static"
                                data-keyboard="false"
                                tabindex="-1"
                                aria-labelledby="staticBackdropLabel"
                                aria-hidden="true"
                            >
                                <div class="modal-dialog modal-dialog-centered">
                                    <div class="modal-content">
                                        <div class="modal-header border-bottom-0 p-0">
                                            <button
                                                type="button"
                                                class="close py-2 pr-3"
                                                data-dismiss="modal"
                                                aria-label="Close"
                                            >
                                                <img src="/maincss/images/cancel.svg" />
                                            </button>
                                        </div>
                                        <div class="modal-body pt-0">
                                            <div class="mx-auto preview-image mb_20">
                                                <img v-if="item.NewOrderItemDecoration.final_proof_image" :src="item.NewOrderItemDecoration.final_proof_image" alt="">
                                                <img v-else alt="" :id="`default-artwork-${index}`" src="/maincss/images/mug_2.png" />
                                            </div>
                                            <div class="mx-auto preview-image">
                                                <button class="btn btn_orange bg_primary_orange text_white" type="button" @click="downloadArtwork(item.NewOrderItemDecoration ? item.NewOrderItemDecoration.art_work : '', 'Artwork', index)">Download</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                         <div v-if="order.remarks" class="col-md-6 ">
                                                           <div class="total-sec-col">
                                                         <h5>Comments</h5> 
                                                         <p> {{order.remarks}}</p>
                                                           </div>
                                                       </div>
                        <div class="col-md-12 total-price">
                            <div class="row justify-content-end m-0 cart-total">
                                <div class="col-md-4 total-sec-col">
                                    <div class="cost_col">
                                        <div class="tp_in cost_v d-flex">
                                            <span class="tp_1 font_size_15 pb_0 pl_10">Total</span><span
                                                class="tp_2 pb_0 font_size_24">{{ icPriceFormat(order.subtotal) }}</span>
                                        </div>
                                        <div class="tp_in cost_v d-flex" v-if="order.total_non_standard_fees>0">
                                            <span class="tp_1 font_size_15 pb_0 pl_10 d-flex align-items-center">Custom Ink Mix Fee
                                                <ul v-if="total_non_standard_colors.length > 0" class="standard_colors">
                                                    <div class="more_color_link dropdown">
                                                        <a 
                                                            href="#" id="dropdownMenuButton551"
                                                            data-toggle="dropdown" aria-haspopup="true"
                                                            aria-expanded="false"
                                                            class="dropdown-toggle d-flex align-items-center"
                                                        >
                                                            <!-- <span class="fee_amount">{{ icPriceFormat(total_non_standard_fees) }}</span>  -->
                                                            <img src="/maincss/images/information.svg" class="ml_6">
                                                        </a>
                                                        <div aria-labelledby="dropdownMenuButton" class="dropdown-menu drop_ink_colors">
                                                            <h4 class="font_size_16 text_primary_blue py_2 px_20">
                                                                Custom Ink Mix Colors
                                                                <span class="cross_ic"><img src="/maincss/images/cross.svg"></span>
                                                            </h4>
                                                            <div class="dropdown-item d-flex align-items-center">
                                                                <!-- eslint-disable -->
                                                                <p class="mb-0">
                                                                    <ul>
                                                                        <li class="w-15" v-for="(color, index) in total_non_standard_colors"
                                                                            :style="'background-color:' + color + ';'"
                                                                            :key="index" v-tooltip="{'content': color, 'autoHide': false}">
                                                                        </li>
                                                                    </ul>
                                                                </p>
                                                                <!-- eslint-enable -->
                                                            </div>
                                                        </div>
                                                    </div>
                                                </ul>
                                            </span>
                                            <span class="tp_2 pb_0 font_size_24 d-flex non_standard">{{ icPriceFormat(order.total_non_standard_fees) }}
                                                
                                            </span>
                                            
                                         
                                         
                                        </div>
                                        <div class="tp_in cost_v d-flex" v-if="order.sales_tax>0">
                                            <span class="tp_1 font_size_15 pb_0 pl_10">Sales Tax</span><span
                                                class="tp_2 pb_0 font_size_24">{{ icPriceFormat(order.sales_tax) }}</span>
                                        </div>
                                        <div class="tp_in cost_v d-flex">
                                            <span class="tp_1 font_size_15 pb_0 pl_10">Shipping Cost</span><span
                                                class="tp_2 pb_0 font_size_24">{{ icPriceFormat(order.ship_cost) }}</span>
                                        </div>
                                        <hr/>
                                        <div class="tp_in cost_v d-flex">
                                            <span class="tp_1 font_size_15 pb_0 pl_10">Grand Total</span><span
                                                class="tp_2 pb_0 font_size_24">{{ icPriceFormat(order.total_price) }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        </template>
                    </div>
                </div>
            </div>
        </div>
        <div class="contact_detail_wrap px_30 pt_40 pb_36 notes_section" v-if="false">
            <div class="text_box_area">
                <form @submit.prevent="addComment()" data-vv-scope="addcommentform">
                    <div class="textbox_heading d-flex">
                        <h4>Notes</h4>
                        <div class="select_option sec_opt">
                            <label>To</label>
                            <v-select label="first_name" :reduce="(users) => users.id" v-model.trim="comment.user_to"
                                :options="users" :placeholder="'User'" name="user" v-validate="'required'" ref="user">
                                <template slot="option" slot-scope="option">
                                    {{ option.first_name }} {{ option.last_name }}
                                </template>
                                <template slot="selected-option" slot-scope="option">
                                    {{ option.first_name }} {{ option.last_name }}
                                </template>
                            </v-select>
                            <small class="form-text text-error text-left"
                                v-show="errors.has('addcommentform.user') && isSubmit">
                                {{ errors.first("addcommentform.user") }}
                            </small>
                        </div>
                    </div>
                    <div class="text_editor">
                        <ckeditor v-model="comment.message" name="description" id="ckeditor" v-validate="'required|max:250'"
                            data-vv-as="Description" ref="editor"></ckeditor>
                        <small class="form-text text-error text-left"
                            v-show="errors.has('addcommentform.description') && isSubmit">
                            {{ errors.first("addcommentform.description") }}
                        </small>
                        <button type="submit" class="
                float-right
                mt-2
                btn btn_outline_primary
                border_primary_blue
                text_primary_blue
              ">
                            Post
                        </button>
                    </div>
                </form>
                <div class="comment_wrap">
                    <div class="comment_section">
                        <h4>Recent Comments ({{ comment_list.length }})</h4>
                        <div class="comment_box_wrap team_img_name d-flex order_comments"
                            v-for="comment in comment_list" :key="comment.id">
                            <div class="comm_img team_img">
                                <span class="font_size_14 font-weight-bold">{{ comment.sender.first_name[0] | capitalize
                                }}{{ comment.sender.last_name[0] | capitalize }}</span>
                            </div>
                            <div class="comment_area font_14">
                                <div class="name_time">
                                    <span class="name">{{
                                            comment.sender.first_name + " " + comment.sender.last_name
                                    }}</span><span class="time grey_color font_size_14">
                                        {{ comment.created_at | formatDateNow }}</span>
                                </div>
                                <div class="comments font_size_14" v-html="comment.message"></div>
                                <div class="reply grey_color font_size_14 rply_form">
                                    <a @click="focusOnEditor()">Reply</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="preloader" v-show="isBusy">
            <div class="preloader-body">
                <svg width="40" height="40" viewBox="0 0 40 40">
                    <polygon class="rect" points="0 0 0 40 40 40 40 0"></polygon>
                </svg>
            </div>
        </div>
    </div>
</template>
<script>
import ApiService from "@/common/api.service";
import DisplayProductImage from "@/components/DisplayProductImageNew";
import OrderDetails from "@/components/payments/OrderDetails";
import { mapGetters } from "vuex";

export default {
    name: "Order_detail",
    components: { DisplayProductImage, OrderDetails },
    data() {
        return {
            comment: {
                message: null,
                user_to: null,
                order_id: this.$route.params.id
            },
            isSubmit: false,
            order_id: this.$route.params.id,
            isBusy: false,
            order: null,
            item_data: [],
            product_color: [],
            users: [],
            comment_list: [],
            decoration_type_list: {
                1: "Print",
                2: "Embroidery",
                3: "Promotional"
            },
            order_fees:[],
            billing_address: {
                first_name:'',
                last_name:'',
                address1: '',
                address2: '',
                city: '',
                state: '',
                country: '',
                zip: '',
                phone: '',
                email: '',
                address_label: ''
            },
            shipping_address: {
                first_name:'',
                last_name:'',
                address1: '',
                address2: '',
                city: '',
                state: '',
                country: '',
                zip: '',
                phone: '',
                email: '',
                address_label: ''
            },
            decoration_methods: null,
            payment_detail_myJSON:null,
            additional_payment: null,
            additional_term_payment: null,
            additional_card_payment: null,
            term_payment_details: null,
            card_payment_details: null,
            total_non_standard_colors: [],
            colors_limit: 6
        };
    },
    computed: {
        ...mapGetters([ "currentUserClient", "isAuthenticatedClient"]),
    },
    mounted() {
        var _this = this;

        if (_this.$route.params.id) {
            _this.getOrderDetail();
            // _this.getComments();
        }
        _this.getDecorationMethods();
        // this.getUsers();
        /* eslint-disable */
        $(function () {
            $("#item2").click(function () {
                $("#submenu2").slideToggle(500);
            });
        });

        $(function () {
            $(".acc__title").click(function (j) {
                var dropDown = $(this).closest(".acc__card").find(".acc__panel");
                $(this).closest(".acc").find(".acc__panel").not(dropDown).slideUp();

                if ($(this).hasClass("active")) {
                    $(this).removeClass("active");
                } else {
                    $(this)
                        .closest(".acc")
                        .find(".acc__title.active")
                        .removeClass("active");
                    $(this).addClass("active");
                }

                dropDown.stop(false, true).slideToggle();
                j.preventDefault();
            });
        });
        /* eslint-enable */
    },
    methods: {
        existsNameAndNumber(data, type) {
        let is_exist = data.find(nn => nn[type] != '');
        return is_exist;
    },
        focusOnEditor() {
            this.$refs.editor.instance.focus();
            document.getElementById("ckeditor").scrollIntoView();
        },
        filterQty(qty) {
            if (qty) {
                return qty.filter((element) => element.qty > 0);
            }
            return [];
        },
        getUsers() {
            var _this = this;
            ApiService.get("/super-users")
                .then(({ data }) => {
                    _this.users = data.users;
                })
                .catch(({ response }) => {
                    console.log(response);
                    if (response.status == 401) {
                        _this.$router.push({ name: "/admin/login" });
                    }
                });
        },
        addComment() {
            var _this = this;
            _this.$validator.validateAll("addcommentform").then((isValid) => {
                _this.isSubmit = true;
                if (isValid) {
                    _this.isBusy = true;
                    ApiService.post("/comments", _this.comment)
                        .then(({ data }) => {
                            _this.getComments();
                            if (data.success) {
                                _this.comment = {
                                    message: "",
                                    user_to: null,
                                    order_id: this.$route.params.id
                                };
                                _this.isBusy = false;
                                _this.$toast.success("Comment added successfully", {
                                    position: "top-right"
                                });
                                setTimeout(() => {
                                    _this.$validator.reset();
                                }, 0);
                            }
                            _this.isBusy = false;
                        })
                        .catch(({ response }) => {
                            if (response.status == 401) {
                                _this.$router.push({ name: "/admin/login" });
                            }
                            _this.isBusy = false;
                        });
                } else {
                    console.log("gjhghj", _this.errors);
                }
            });
        },
        getDesignCost(imprint) {
            // console.log(imprint);
            if (imprint) {
                return imprint.reduce((cost, element) => {
                    if (element.is_selected) {
                        const sum = element.colors.reduce(function (total, number) {
                            return total + parseFloat(number.color_cost);
                        }, 0);
                        return cost + parseFloat(sum);
                    } else {
                        return cost;
                    }
                }, 0);
            }
            return 0.0;
        },
        getArtwork(art) {
            let display_text = "";
            if (art) {
                let artwork;
                try {
                    artwork = JSON.parse(JSON.parse(art));
                } catch (error) { console.log(error); }

                if (artwork.decoration_type == 1) {
                    display_text = "Print";
                } else if (artwork.decoration_type == 2) {
                    display_text = "Embroidery";
                } else if (artwork.decoration_type == 3) {
                    display_text = "Promotional";
                }
            }
            return display_text;
        },
        getComments() {
            var _this = this;
            _this.isBusy = true;
            new Promise(() => {
                ApiService.post("/item-comments", { order_id: _this.order_id })
                    .then(({ data }) => {
                        _this.comment_list = data.comments;
                        _this.isBusy = false;
                    })
                    .catch(({ response }) => {
                        _this.isBusy = false;
                        // console.log(response, "aaaa");
                        if (response.status == 401) {
                            _this.$router.push({ name: "/admin/login" });
                        }
                    });
            });
        },
        getOrderDetail() {
            var _this = this;
            _this.isBusy = true;
            new Promise((resolve) => {
                ApiService.get("/neworderdetail/" + _this.order_id).then(({ data }) => {
                    if (!data.success) {
                        this.$toast.error(data.error, { position: 'top-right', queue: true });
                        this.isBusy = false;
                        return;
                    }
                    let order = data.order;
                    if (!order || (order.User.id!=this.currentUserClient.id)) {
                        this.$router.replace({name: '404'});
                        return;
                    }

                    // Actual Payment
                    let term_payment_details = order.NewOrderPayments.find(payment => payment.type == 'termPayment');
                    if (term_payment_details && term_payment_details.payment_details) {
                        term_payment_details.payment_details = term_payment_details.payment_details
                            ? JSON.parse(term_payment_details.payment_details)
                            : null;
                    }
                    this.term_payment_details = term_payment_details;
                    

                    let card_payment_details = order.NewOrderPayments.find(payment => (payment.type == 'credit card'));
                    if (card_payment_details && card_payment_details.payment_details) {
                        card_payment_details.payment_details = card_payment_details.payment_details
                            ? JSON.parse(card_payment_details.payment_details)
                            : null;
                    }
                    this.card_payment_details = card_payment_details;

                    // ADDITIONAL PAYMENT
                    let additional_term_payment = order.NewOrderPayments.find(payment => (payment.type == 'termPayment') && (payment.is_additional_payment == 1));
                    if (additional_term_payment && additional_term_payment.payment_details) {
                        additional_term_payment.payment_details = additional_term_payment.payment_details
                            ? JSON.parse(additional_term_payment.payment_details)
                            : null;
                    }
                    this.additional_term_payment = additional_term_payment;
                    if (this.additional_term_payment && this.additional_term_payment.payment_details && this.additional_term_payment.payment_details.prices) {
                        this.additional_payment = this.additional_term_payment.payment_details.prices;
                    }

                    let additional_card_payment = order.NewOrderPayments.find(payment => (payment.type == 'credit card')  && (payment.is_additional_payment == 1));
                    if (additional_card_payment && additional_card_payment.payment_details) {
                        additional_card_payment.payment_details = additional_card_payment.payment_details
                            ? JSON.parse(additional_card_payment.payment_details)
                            : null;
                    }
                    this.additional_card_payment = additional_card_payment;
                    if (this.additional_card_payment && this.additional_card_payment.payment_details && this.additional_card_payment.payment_details.prices) {
                        this.additional_payment = this.additional_card_payment.payment_details.prices;
                    }


                    let obj= order.payment_data
                    _this.payment_detail_myJSON = JSON.parse(obj);
                        //order fees
                    let order_fees = data.order.OrderReviewFees;
                    
                    if(order_fees){
                        order_fees.forEach(fees => {
                        if(fees.decoration_title==null){
                            this.order_fees.push({decoration_title:'Order Fee',decoration_fee:fees.decoration_fee});
                            
                        }else{
                            this.order_fees.push({decoration_title:fees.decoration_title,decoration_fee:fees.decoration_fee});
                            
                        }
                        
                        });

                    }
                    // Address
                    let order_addresses = data.order.NewOrderAddresses;
                    if (order_addresses) {
                        let billing_address = order_addresses.find(address => address.is_billing);
                        let shipping_address = order_addresses.find(address => address.is_shipping);
                        if (billing_address) {
                            this.billing_address = {
                                first_name: billing_address.first_name,
                                last_name: billing_address.last_name,
                                address_label: billing_address.company_name,
                                address1: billing_address.address_line1,
                                address2: billing_address.address_line2,
                                city: billing_address.city,
                                state: billing_address.state,
                                country: billing_address.country,
                                zip: billing_address.zip,
                                phone: billing_address.phone,
                                email: billing_address.email,
                            };
                            if (!shipping_address) {
                                this.shipping_address = this.billing_address
                            }
                        }


                        if (shipping_address) {
                            this.shipping_address = {
                                first_name: shipping_address.first_name,
                                last_name: shipping_address.last_name,
                                shippingaddress_label: shipping_address.company_name,
                                address1: shipping_address.address_line1,
                                address2: shipping_address.address_line2,
                                city: shipping_address.city,
                                state: shipping_address.state,
                                country: shipping_address.country,
                                zip: shipping_address.zip,
                                phone: shipping_address.phone,
                                email: shipping_address.email,
                            };
                            if (!billing_address) {
                                this.billing_address = this.shipping_address
                            }
                        }
                    }
                    let order_items = [];
                    let all_setup_fee=0;
                    let subtotal = 0;
                    let total_discount = 0;
                    let front_art_url;
                    let total_non_standard_colors = []
                    
                    data.order.NewOrderItems.forEach((item) => {
                                             
                        
                        if (item.MainNewSubProduct && item.MainNewSubProduct.MainNewProducts) {
                            let item_setup_fee=0;
                            // Create a copy of MainNewProducts to preserve all properties
                            let order_item = {
                                ...item.MainNewSubProduct.MainNewProducts
                            };
                            // Ensure essential properties are preserved
                            if (!order_item.id) {
                                order_item.id = item.MainNewSubProduct.parent_product_id;
                            }
                            if (!order_item.name && order_item.product_number) {
                                order_item.name = order_item.product_number;
                            }
                            order_item.gender_size_id = item.gender_size_id;
                            order_item.unique_item_id = item.unique_item_id;
                            order_item.color = item.MainNewSubProduct.Color;
                            order_item['NewOrderItemDecoration'] = item.NewOrderItemDecoration;
                            let index = order_items.findIndex(item_data =>
                                (item_data.id == item.MainNewSubProduct.parent_product_id) &&
                                (item_data.color && item_data.color.id == item.MainNewSubProduct.color_id) &&
                                (item_data.gender_size_id == item.gender_size_id) &&
                                (item_data.unique_item_id == item.unique_item_id)
                            );
                            item_setup_fee=item_setup_fee+parseFloat(item.setup_fee);
                            
                            // Track discount for subtotal calculation
                            if (item.discount) {
                                total_discount += parseFloat(item.discount || 0);
                            }
                            if ((index >= 0) && order_items[index]) {
                                order_items[index]['sizes'].push(item);
                                order_items[index]['total_quantity']+=item.quantity;
                                order_items[index]['total_price']+=parseFloat(item.total_price) + parseFloat(item.discount);
                                order_items[index]['total_discount']+=parseFloat(item.discount);
                                order_items[index]['total_extra_fees']+=parseFloat(item['single_location_price']) * parseFloat(item['quantity']);
                                order_items[index]['total_single_location_price']+=parseFloat(item.single_location_price)* parseFloat(item['quantity']);
                                
                                // For grouped items, sum item_sub_total from all sizes
                                if (item.item_sub_total) {
                                    if (!order_items[index]['item_sub_total']) {
                                        order_items[index]['item_sub_total'] = 0;
                                    }
                                    order_items[index]['item_sub_total'] += parseFloat(item.item_sub_total || 0);
                                }
                                
                                // Copy breakdown fields from first size if not already set
                                if (!order_items[index]['base_fee'] && item.base_fee) {
                                    order_items[index]['base_fee'] = typeof item.base_fee === 'string' ? JSON.parse(item.base_fee) : item.base_fee;
                                }
                                if (!order_items[index]['run_charge_breakdown'] && item.run_charge_breakdown) {
                                    order_items[index]['run_charge_breakdown'] = typeof item.run_charge_breakdown === 'string' ? JSON.parse(item.run_charge_breakdown) : item.run_charge_breakdown;
                                }
                                if (!order_items[index]['rush_fee_breakdown'] && item.rush_fee_breakdown) {
                                    order_items[index]['rush_fee_breakdown'] = typeof item.rush_fee_breakdown === 'string' ? JSON.parse(item.rush_fee_breakdown) : item.rush_fee_breakdown;
                                }
                                if (!order_items[index]['setup_fees_details'] && item.setup_fees_details) {
                                    order_items[index]['setup_fees_details'] = typeof item.setup_fees_details === 'string' ? JSON.parse(item.setup_fees_details) : item.setup_fees_details;
                                }
                                if (!order_items[index]['custom_color_fee'] && item.custom_color_fee) {
                                    order_items[index]['custom_color_fee'] = typeof item.custom_color_fee === 'string' ? JSON.parse(item.custom_color_fee) : item.custom_color_fee;
                                }
                            } else {
                                order_item['sizes'] = [ item ];
                                
                                order_item['total_quantity']=item.quantity;
                                order_item['setup_fee']=item_setup_fee;
                                order_item['total_price']=parseFloat(item.total_price) + parseFloat(item.discount);
                                order_item['total_discount']=parseFloat(item.discount);
                                order_item['design_fee']=parseFloat(item.design_fee);
                                order_item['name_number_fees']=parseFloat(item.name_number_fees);
                                order_item['non_standard_fees']=parseFloat(item.non_standard_fees);
                                order_item['item_sub_total'] = item.item_sub_total ? parseFloat(item.item_sub_total) : null;
                                
                                // Copy breakdown fields from item to order_item
                                order_item['base_fee'] = item.base_fee ? (typeof item.base_fee === 'string' ? JSON.parse(item.base_fee) : item.base_fee) : [];
                                order_item['run_charge_breakdown'] = item.run_charge_breakdown ? (typeof item.run_charge_breakdown === 'string' ? JSON.parse(item.run_charge_breakdown) : item.run_charge_breakdown) : [];
                                order_item['rush_fee_breakdown'] = item.rush_fee_breakdown ? (typeof item.rush_fee_breakdown === 'string' ? JSON.parse(item.rush_fee_breakdown) : item.rush_fee_breakdown) : null;
                                order_item['setup_fees_details'] = item.setup_fees_details ? (typeof item.setup_fees_details === 'string' ? JSON.parse(item.setup_fees_details) : item.setup_fees_details) : null;
                                order_item['custom_color_fee'] = item.custom_color_fee ? (typeof item.custom_color_fee === 'string' ? JSON.parse(item.custom_color_fee) : item.custom_color_fee) : [];
                                
                                order_item['non_standard_colors']= item.non_standard_colors
                                    ? JSON.parse(item.non_standard_colors)
                                    : [];
                                order_item['decoration_colors']= item.decoration_colors
                                    ? JSON.parse(item.decoration_colors)
                                    : [];
                                // order_item.artwork_colors = [...new Set(order_item.standard_colors.concat(order_item.non_standard_colors))];
                                total_non_standard_colors = total_non_standard_colors.concat(order_item['non_standard_colors']);
                                order_item['imprint_locations'] = item.imprint_locations ? JSON.parse(item.imprint_locations) : [];
                                order_item['imprint_locations'] = order_item['imprint_locations'].filter(imprint_location => imprint_location.is_selected);
                                order_item['color_fee'] = 0;

                                // Handle product images with proper null checks
                                if (order_item.MainNewProductsImages && Array.isArray(order_item.MainNewProductsImages) && order_item.MainNewProductsImages.length > 0) {
                                    order_item['product_image'] = order_item.MainNewProductsImages.find(image => image.color_id == order_item.color.id);
                                    if (!order_item['product_image']) {
                                        order_item['product_image'] = order_item.MainNewProductsImages[0];
                                    }
                                } else {
                                    order_item['product_image'] = null;
                                }
                                
                                // order_item['design_image'] = JSON.parse(item.design_image)[0]['url'];
                                order_item['build_id'] = item.build_id;
                                order_item['design_images'] = item.design_image ? JSON.parse(item.design_image) : [];
                                if (order_item['design_images'] && order_item['design_images'].length > 0) {
                                    order_item['design_image'] = JSON.parse(item.design_image)[0]['url'];
                                    if (front_art_url!=order_item['design_images'][0]['design_image']) {
                                        order_item['front_art_url'] = order_item['design_images'][0]['design_image'];
                                        front_art_url = order_item['front_art_url'];
                                    }

                                    if (item.OrderBuild) {
                                        order_item['OrderBuild'] = item.OrderBuild;
                                    }
                                }
                                // console.log('check all design for images here=================================', order_item['design_images']);
                                order_item['name_and_number_json'] = item.name_and_number_json;
                                order_item['name_and_number_json'] = order_item['name_and_number_json']
                                    ? JSON.parse(order_item['name_and_number_json'])
                                    : [];
                                order_item['name_and_number_json'] = order_item['name_and_number_json'].filter(nn => nn.name!="" || nn.number);
                                // console.log('check all the name and numbers in order details pages==============', item.name_and_number_json);
                                order_item['imprint_locations'].forEach(location => {
                                    order_item['color_fee']+=parseFloat(location['total_decoration_fee']);
                                    if (location.is_selected) {
                                        location.colors.forEach(color => {
                                        //     if (color.decor_upcharge) {
                                        //         order_item['color_fee']+=parseFloat(color.decor_upcharge.color_cost) + parseFloat(color.cost_cost);
                                        //     } else {
                                        //         order_item['color_fee']+=parseFloat(color.cost_cost);
                                        //     }
                                            order_item['color_fee']+=parseFloat(color.total_decor_upcharge);
                                        });
                                    }
                                });

                                order_item['total_single_location_price'] = parseFloat(item['single_location_price']) * parseFloat(item['quantity']);

                                order_item['total_extra_fees'] = parseFloat(item['design_fee']) 
                                    + parseFloat(order_item['color_fee']) 
                                    + parseFloat(item['single_location_price']) * parseFloat(item['quantity']);

                                subtotal+=parseFloat(order_item.color_fee);
                                order_items.push(order_item);
                            }
                            all_setup_fee=all_setup_fee+item_setup_fee;
                        } else {
                            // Debug: Log items that don't match the condition
                            console.warn('Item skipped - Missing MainNewSubProduct or MainNewProducts:', item);
                            console.warn('Item has MainNewSubProduct:', !!item.MainNewSubProduct);
                            if (item.MainNewSubProduct) {
                                console.warn('MainNewSubProduct has MainNewProducts:', !!item.MainNewSubProduct.MainNewProducts);
                            }
                        }
                    });


                    // PRICE BREAKUPS
                    order_items.forEach(order_item => {
                        order_item.base_price = 0;
                        order_item.markup_price = 0;
                        order_item.markup_percentage = 0;
                        order_item.ink_price = 0;
                        order_item.single_location_price = 0;
                        order_item.sizes.forEach(size => {
                            order_item.base_price+=parseFloat(size.base_price)*parseInt(size.quantity);
                            order_item.ink_price+=parseFloat(size.ink_price);
                            order_item.single_location_price=parseFloat(size.single_location_price);
                            order_item.markup_price+=parseFloat(size.markup_price)*parseInt(size.quantity);
                            order_item.markup_percentage=size.markup_percentage;
                        });
                        // order_item.base_price = order_item.base_price * parseInt(order_item.total_quantity)
                        order_item.ink_price = parseFloat(order_item.ink_price) * parseInt(order_item.total_quantity);
                        order_item.single_location_price = parseFloat(order_item.single_location_price) * parseInt(order_item.total_quantity);
                        // order_item.markup_price = order_item.markup_price * order_item.total_quantity;
                    });

                    // Calculate subtotal from item_sub_total (like OrderDetails component)
                    subtotal = 0;
                    let calculated_total_discount = 0;
                    order_items.forEach((order_item) => {
                        if (order_item.item_sub_total) {
                            subtotal += parseFloat(order_item.item_sub_total);
                        } else {
                            // Fallback to old calculation if item_sub_total is not available
                            subtotal += parseFloat(order_item.total_price || 0);
                        }
                        // Calculate total discount from all sizes in this item
                        if (order_item.sizes && Array.isArray(order_item.sizes)) {
                            order_item.sizes.forEach((size) => {
                                if (size.discount) {
                                    calculated_total_discount += parseFloat(size.discount || 0);
                                }
                            });
                        } else if (order_item.total_discount) {
                            // Fallback: use total_discount if available
                            calculated_total_discount += parseFloat(order_item.total_discount || 0);
                        }
                    });
                    
                    // Subtract total discount from subtotal
                    order.subtotal = subtotal - calculated_total_discount;
                    
                    order.NewOrderItems = order_items;
                    order.total_setup_fee=all_setup_fee;
                    
                    // Prepare data for OrderDetails component
                    // OrderDetails expects order_detail.items instead of NewOrderItems
                    let processedOrder = JSON.parse(JSON.stringify(order));
                    processedOrder.items = order_items;
                    
                    _this.order = order;
                    _this.processedOrderData = processedOrder;
                    _this.total_non_standard_colors = [...new Set(total_non_standard_colors)];
                    _this.isBusy = false;
                    resolve(data);
                }).catch((err) => {
                    console.log(err);
                    _this.isBusy = false;
                    // reject(response);
                });
            });
        },
        getShippingStateAndZipCode(id, address = "billing_full_address") {
            var _this = this;
            new Promise(() => {
                ApiService.post("/getstateandzipcode/" + id)
                    .then(({ data }) => {
                        _this.$set(
                            _this.order_id,
                            address,
                            data.zipAndState.complete_address
                        );
                    })
                    .catch(({ response }) => {
                        if (response.status == 401) {
                            _this.$router.push({ name: "/admin/login" });
                        }
                    });
            });
        },
        productColors(color) {
            if (color) {
                let style = color.swatches
                    ? "background-image:url(" + color.swatches + ")"
                    : " background-color:" + color.hex;

                let html =
                    `  <a href="javascript:void(0)"
                             class="color_circle mr_16 bg_secondary_black "
                             style="` +
                    style +
                    `"></a>`;
                return html;
            }
            return "";
        },
        converToCamel(text) {
            return text.replace(
                /(^\w|\s\w)(\S*)/g,
                (_, m1, m2) => m1.toUpperCase() + m2.toLowerCase()
            );
        },
        openCostPopup() {
            /* eslint-disable */
            $(function () {
                $(".cart_tbl_mobile").addClass("set-popup-size");
                $(document).on("click", function (e) {
                    if ($(e.target).is(".cart_tbl_mobile") === false) {
                        $(".cart_tbl_mobile").removeClass("set-popup-size");
                    }
                });
            });
            /* eslint-enable */
        },
        downloadArtwork(uri, name) {
            var link = document.createElement("a");
            link.download = name;
            link.href = uri;
            link.target="_blank";
            if (!uri) {
                link.href = '/maincss/images/mug_2.png';
            }
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        getDecorationMethods() {
            return new Promise((resolve, reject) => {
                ApiService.get('/decoration-methods').then(({ data }) => {
                    this.decoration_methods = data.decoration_methods;
                    resolve(data)
                }).catch(error => {
                    reject(error);
                });
            })
        },
        getDecorationMethodName(type) {
            if (!this.decoration_methods) {
                return '';
            }
            let decoration_data = this.decoration_methods.find(method => method.id == type);
            if (decoration_data) {
                return decoration_data.name;
            }

            return '';
        },
        showDesignImages(data) {
            if (data) {
                let json = data;
                json = json.filter(img => img.canvas_images.length > 0);
                if (json.length > 0) {
                    return true;
                }
            }
            return false;
        },

        hasLimit(item, index) {
            if (!item.is_color_show_more) {
                return index < this.colors_limit;
            }
            return true;
        },

        
        getBase64Image() {
            var request = require('request').defaults({ encoding: null });
            const baseImageUrl = process.env.VUE_APP_BASE_IMAGE_URL;
            const imageUrl = `${baseImageUrl}/6374.png`;
 
            request.get(imageUrl, function (error, response, body) {
                if (!error && response.statusCode == 200) {
                    let data = "data:" + response.headers["content-type"] + ";base64," + Buffer.from(body).toString('base64');
                    console.log(data);
                }
            });
        },

        with2Decimals(num) {
            // this.$with2Decimals(num);
            var with2Decimals = num.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0]
            return parseFloat(with2Decimals);
        }
    },
    filters: {
        productTitleExceed(value) {
            if (!value) {
                return "";
            }
            return value.substring(0, 50) + "....";
        }
    },
    
};
</script>
<style>
.image-button-design{
    font-size: 15px;
    letter-spacing: 1.73px;
    text-align: center;
    color: #0079c1!important;
    padding: 16px 26px;
    min-width: 100px!important;
    border-color: #0079c1!important;
    text-transform: uppercase;
    background: #fff;
    margin-top: 10px;
    border-radius: 4px;
}
.cart_modal_s-img{
    max-width: 1400px;
}
.cart_modal_s-img .product_details-cart{
    margin: 0!important;
    padding: 10px!important;
    max-width: 224px;
    max-height: 303px;
    height: 100%;
    min-height: 194px;
}
.cart_modal_s-img .product_details-cart .choice_img{
    border: 1px solid #000;
    padding: 0;
    min-height: 185px;
    display: flex;
    -webkit-box-align: baseline;
    align-items: baseline;
    -webkit-box-pack: center;
    justify-content: center;
}
.cart_modal_s-img .product_details-cart .choice_img img{
    width: 100%;
    height: auto;
    max-height: 150px;
    padding: 5px;
    max-width: 100%;
}
.cart_modal_s-img .product_details-cart .choice_img .order_shape_title{
    text-align: center;
    font-size: 14px;
    font-weight: 700;
    color: rgba(0,0,0,.7294117647);
    background-color: #ececec;
    width: 90%;
    text-transform: capitalize;
    padding: 4px;
    line-height: 24px;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    position: absolute;
    bottom: 10px;
}
.cart_modal_s-img .product_details-cart .choice_img .dimension_text{
    position: absolute;
    right: 11px;
    font-size: 15px;
    font-weight: 600;
    background-color: #ececec;
    width: 90%;
    text-align: center;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}
.cart_modal_s-img .main_title {
    margin-left: 10px;
}
.cart_modal_s-img .image-align-col {
    margin-left: 0px;
}
.cart_modal_s-img .main_title h5{
    color: #000 !important;
}
.cart_modal_s-img .modal-scroll{
    overflow: auto;
    max-height: 600px;
}

</style>
